module.exports = __webpack_public_path__ + "img/review_2x.36df5a73.png";